import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Locale configuration
export const localeConfig = {
  en: {
    name: 'English',
    nativeName: 'English',
    direction: 'ltr',
    dateFormat: 'MM/dd/yyyy',
    timeFormat: 'HH:mm',
    currency: 'USD',
    numberFormat: {
      decimal: '.',
      thousands: ',',
      precision: 2
    }
  },
  ar: {
    name: 'Arabic',
    nativeName: 'العربية',
    direction: 'rtl',
    dateFormat: 'dd/MM/yyyy',
    timeFormat: 'HH:mm',
    currency: 'SAR',
    numberFormat: {
      decimal: ',',
      thousands: '.',
      precision: 2
    }
  }
};

// Initialize i18next with proper error handling
const initI18n = async () => {
  try {
    await i18n
      // Load translations from /public/locales
      .use(Backend)
      // Detect user language
      .use(LanguageDetector)
      // Pass the i18n instance to react-i18next
      .use(initReactI18next)
      // Initialize i18next
      .init({
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        
        // Backend configuration
        backend: {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
          // Add error handling for missing translation files
          request: (options, url, payload, callback) => {
            try {
              fetch(url)
                .then(res => {
                  if (!res.ok) {
                    throw new Error(`Failed to load translations: ${res.status}`);
                  }
                  return res.json();
                })
                .then(data => {
                  callback(null, {
                    data: data,
                    status: 200
                  });
                })
                .catch(err => {
                  console.warn(`Translation file not found for ${url}, using fallback`);
                  callback(null, {
                    data: {},
                    status: 404
                  });
                });
            } catch (err) {
              console.warn(`Error loading translations: ${err.message}`);
              callback(null, {
                data: {},
                status: 500
              });
            }
          }
        },
        
        // Language detection
        detection: {
          order: ['localStorage', 'navigator', 'htmlTag'],
          caches: ['localStorage'],
        },
        
        // Interpolation
        interpolation: {
          escapeValue: false, // React already escapes values
        },
        
        // Namespaces
        ns: ['translation'],
        defaultNS: 'translation',
        
        // React i18next options
        react: {
          useSuspense: false, // Disable Suspense for better error handling
        },
        
        // Supported languages
        supportedLngs: Object.keys(localeConfig),
        
        // Load all namespaces
        load: 'languageOnly',
        
        // Ensure proper initialization
        initImmediate: false,
        
        // Add retry logic for failed loads
        retry: {
          retries: 3,
          retryDelay: 1000
        }
      });
    
    console.log('i18next initialized successfully');
  } catch (error) {
    console.error('Failed to initialize i18next:', error);
    // Fallback initialization with minimal config
    await i18n
      .use(initReactI18next)
      .init({
        fallbackLng: 'en',
        debug: false,
        react: {
          useSuspense: false,
        },
        resources: {
          en: {
            translation: {
              // Add basic fallback translations
              navigation: {
                dashboard: 'Dashboard',
                patients: 'Patients',
                appointments: 'Appointments',
                billing: 'Billing',
                facilities: 'Facilities',
                encounters: 'Encounters',
                prescriptions: 'Prescriptions',
                pharmacy: 'Pharmacy',
                messaging: 'Messaging',
                care_coordination: 'Care Coordination',
                bi_reporting: 'BI Reporting',
                compliance: 'Compliance',
                quality_metrics: 'Quality Metrics'
              }
            }
          }
        }
      });
  }
};

// Initialize immediately
initI18n();

export default i18n; 